import { render, staticRenderFns } from "./growthSalesStatus.vue?vue&type=template&id=18f4a5e8&scoped=true"
import script from "./growthSalesStatus.vue?vue&type=script&lang=js"
export * from "./growthSalesStatus.vue?vue&type=script&lang=js"
import style0 from "./growthSalesStatus.vue?vue&type=style&index=0&id=18f4a5e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4a5e8",
  null
  
)

export default component.exports